'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/history/lib/ExecutionEnvironment.js
 ** module id = 282
 ** module chunks = 1
 **/